/**
 * HM-083 — Cheatsheet keyboard shortcuts (overlay).
 *
 * Apertura via "?" (gestito da `useKeyboardShortcuts`). Chiusura via Esc
 * o click sul backdrop.
 *
 * Ref: tasks.md HM-083, UX_FLOWS.md §1 (interazioni reception).
 */

type Props = {
  open: boolean;
  onClose: () => void;
};

const ROWS: Array<[string, string]> = [
  ['/', 'Focus barra di ricerca'],
  ['r', 'Ricarica camere e prenotazioni'],
  ['c', 'Check-in rapido (richiede selezione camera — Fase 2)'],
  ['o', 'Check-out rapido (richiede selezione camera — Fase 2)'],
  ['?', 'Mostra/nascondi questo pannello'],
  ['Esc', 'Chiudi modal/overlay'],
];

export function ShortcutsHelp({ open, onClose }: Props) {
  if (!open) return null;
  return (
    <div
      // biome-ignore lint/a11y/useSemanticElements: overlay manuale.
      role="dialog"
      aria-modal="true"
      aria-labelledby="shortcuts-title"
      data-testid="shortcuts-help"
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onClose();
      }}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.6)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 1100,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        role="document"
        style={{
          background: '#fff',
          padding: '1.25rem 1.5rem',
          borderRadius: 8,
          width: 'min(420px, 96vw)',
          // HM-600 iPad UX: pannello entro 90vh con scroll interno.
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
      >
        <header
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 8,
          }}
        >
          <h2 id="shortcuts-title" style={{ margin: 0, fontSize: '1.05rem' }}>
            Scorciatoie tastiera
          </h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="chiudi"
            style={{
              minHeight: 44,
              minWidth: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.25rem',
              lineHeight: 1,
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            ×
          </button>
        </header>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
          <tbody>
            {ROWS.map(([key, descr]) => (
              <tr key={key}>
                <td
                  style={{
                    padding: '6px 0',
                    width: 80,
                    fontFamily: 'ui-monospace, SFMono-Regular, monospace',
                  }}
                >
                  <kbd
                    style={{
                      background: '#f1f5f9',
                      border: '1px solid #cbd5e1',
                      borderRadius: 4,
                      padding: '2px 6px',
                    }}
                  >
                    {key}
                  </kbd>
                </td>
                <td style={{ padding: '6px 0', color: '#334155' }}>{descr}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p style={{ marginTop: 12, color: '#94a3b8', fontSize: 12 }}>
          Le scorciatoie sono inattive mentre digiti in un campo.
        </p>
      </div>
    </div>
  );
}
